<template>
    <div v-if="isOpen" class="ui-modal-narrow">
        <div class="ui-modal-narrow__overlay" @click="closeModal"></div>

        <div class="ui-modal-narrow__container">
            <button class="ui-modal-narrow__close-button" @click="closeModal">
                <slot name="close-icon">
                    <img v-svg-inline src="@/assets/icons/ui/modal-close.svg" />
                </slot>
            </button>

            <transition name="ui-modal-slide">
                <div v-show="showContent" class="ui-modal-narrow__content">
                    <slot></slot>
                </div>
            </transition>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { onMounted, ref } from 'vue';

    defineProps({
        isOpen: Boolean,
    });

    const emit = defineEmits(['close']);

    const showContent = ref<boolean>(false);

    function closeModal(): void {
        emit('close');
    }

    onMounted(() => {
        showContent.value = true;
    });
</script>

<style scoped lang="scss">
    @use './UIModalNarrow.scss' as *;
</style>
